export const getCurrencyCodeFromCookie = () => {
  try {
    const arr = document.cookie.match(/NEXT_CURRENCY_CODE=([^;]+)/)
    return arr ? arr[1] : "VND"
  } catch (error) {
    return "VND"
  }
}
